export default __webpack_public_path__ + "intersection.png";